// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------
import { Modal, Form, Input } from "antd";
import { ColorPicker } from "antd";
import { Select } from "antd";
// --------------------- Import Styles ---------------------
import { formStyle, layout, Title } from "../../ViewGerenciarPostagens/styles";

// --------------------- Import Hooks ---------------------

// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useCadastrarEtiqueta} from "../hooks/useCadastrarEtiqueta";

export default function ModalAdicionar({ isModalOpen, handleFechar }: any) {
  const [formAdicionarEtiqueta] = Form.useForm();

  const [etiqueta, setEtiqueta] = useState<any>();

  

    const CORES_PADRAO = [
      { nome: "Azul", cor: "#007BFF" },
      { nome: "Verde", cor: "#28A745" },
      { nome: "Vermelho", cor: "#DC3545" },
      { nome: "Amarelo", cor: "#FFC107" },
      { nome: "Roxo", cor: "#6F42C1" },
      { nome: "Laranja", cor: "#FD7E14" },
      { nome: "Ciano", cor: "#17A2B8" },
      { nome: "Rosa", cor: "#E83E8C" },
      { nome: "Cinza", cor: "#6C757D" },
      { nome: "Verde Claro", cor: "#20C997" },
      { nome: "Azul Claro", cor: "#5BC0DE" },
      { nome: "Marrom", cor: "#795548" },
    ];


  // Chamada da função de atualização
  const {
    cadastrar,
    isLoading: isLoadingAtualizar,
    error,
    success,
    resetError,
  } = useCadastrarEtiqueta();

  // Função que armazena os dados alterados de Apartamento
  const EtiquetaChange = (changedValues: Partial<any>, allValues: any) => {
    setEtiqueta(allValues);
  };

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estados para controlar as exibições
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  const { TextArea } = Input;

  useEffect(() => {
    if (isModalOpen) {
      // Exibe a mensagem de sucesso
      if (success && !successDisplayed) {
        const msgSuccess = "Etiqueta cadastrada com sucesso!";
        showSuccess(msgSuccess);
        setSuccessDisplayed(true);

        // Limpa estado de sucesso após 3 segundos e recarrega a página
        setTimeout(() => {
          setSuccessDisplayed(false);
          navigate(0);
        }, 3000);
      }

      // Exibe a mensagem de erro
      if (error && !errorDisplayed) {
        const msgError =
          "Não foi possível cadastrar a etiqueta! Tente Novamente!";
        showError(msgError);
        setErrorDisplayed(true);

        // Limpa estado de error após 3 segundos
        setTimeout(() => {
          setErrorDisplayed(false);
          resetError();
        }, 3000);
      }
    } else {
      // Reseta os estados ao fechar o modal
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
      setWarningDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    showError,
    errorDisplayed,
    successDisplayed,
    warningDisplayed,
    resetError,
    navigate,
  ]);

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
  };
  /* eslint-enable no-template-curly-in-string */

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Cadastrar"
        onOk={() => cadastrar(etiqueta)}
        confirmLoading={isLoadingAtualizar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>

            <Form
              {...layout}
              form={formAdicionarEtiqueta}
              onValuesChange={(changedValues, allValues) =>
                EtiquetaChange(changedValues, allValues)
              }
              name="Etiqueta"
              style={formStyle}
              validateMessages={validarFormulario}
            >
              <Title>Cadastrar Etiqueta</Title>
              <Form.Item name={"nome"} label="Nome " className="formItems">
                <Input />
              </Form.Item>

              <Form.Item
                name={"descricao"}
                label="Descrição"
                className="formItems"
              >
                <Input />
              </Form.Item>
             <Form.Item
              name={"cor"}
              label="Cor"
              className="formItems"
              rules={[{ required: true, message: "A cor é necessária!" }]}
            >
              <Select
                placeholder="Selecione uma cor"
                onChange={(value) =>
                  setEtiqueta((prev: any) => ({
                    ...prev,
                    cor: value,
                  }))
                }
              >
                {CORES_PADRAO.map((item) => (
                  <Select.Option key={item.cor} value={item.cor}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div
                        style={{
                          width: 16,
                          height: 16,
                          borderRadius: "50%",
                          backgroundColor: item.cor,
                          border: "1px solid #ccc",
                        }}
                      />
                      {item.nome}
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>


            
            </Form>
          </>
        }
      </Modal>
    </>
  );
}
